import React, { useState } from "react";
import { withStyles, Typography, Container, Card, Box } from "@material-ui/core";
import EventStep from "../../core/models/EventStep";
import { CLIENTE_NOTIFICADO } from "../../core/models/Enum/EventActionStep";

const WhiteTextTypography = withStyles({
  root: {
    color: "#FFFFFF",
  },
})(Typography);

const RedTextTypography = withStyles({
  root: {
    color: "#eb4034",
    fontSize: "small",
    fontWeight: "bold",
  },
})(Typography);

type EventStepCommentSectionProps = {
  selectedStep: EventStep;
  loading?: boolean;
  stepLabel: string;
};

const EventStepCommentSection = ({
  selectedStep,
  loading = false,
  stepLabel,
}: EventStepCommentSectionProps) => (
  <Container maxWidth={"xl"} style={{ marginBottom: "1rem" }}>
    <Card>
      <div>
        <Box p={1} flexGrow={1} bgcolor="#6B717F">
          <WhiteTextTypography>{`Detalhes da ação (${stepLabel})`}</WhiteTextTypography>
        </Box>
      </div>
      <div>
        {selectedStep?.etapa_evento === 6 ? (
          <div>
            <Box p={1} flexGrow={1} bgcolor="background.paper">
              <RedTextTypography>
                Isenção automática da cobrança, pois cliente está configurado como exceção para este tipo de evento
              </RedTextTypography>
            </Box>
          </div>
          ) : (
            ""
          )}
      </div>
      <div style={{ width: "100%" }}>
        {selectedStep.comentario || selectedStep.lista_destinatarios ? (
          <>
            {selectedStep.comentario ? (
              <>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="flex-start"
                  style={{paddingLeft: 8, paddingTop:8}}
                  m={1}
                  bgcolor="background.paper"
                >
                  <b>Comentário</b>
                </Box>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="flex-start"
                  style={{paddingLeft: 8, fontSize: 11, color: 'rgb(96, 96, 96)'}}
                  m={1}
                  bgcolor="background.paper"
                >
                  {selectedStep.aprovador}
                </Box>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="flex-start"
                  p={1}
                  m={1}
                  style={{marginTop:0, paddingTop:0}}
                  bgcolor="background.paper"
                >
                  {selectedStep.comentario}
                </Box>
              </>
            ) : null}
            {selectedStep.lista_destinatarios ? (
              <>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="flex-start"
                  p={1}
                  m={1}
                  style={{marginTop:0, paddingTop:0, marginBottom: 0}}
                  bgcolor="background.paper"
                >
                  <b>Usuários Notificados</b>
                </Box>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="flex-start"
                  p={1}
                  m={1}
                  style={{marginTop:0, paddingTop:0}}
                  bgcolor="background.paper"
                >
                  {selectedStep.lista_destinatarios.split(";").join(", ")}
                </Box>
              </>
            ) : null}
          </>
        ) : (
          <>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="flex-start"
              p={1}
              m={1}
              bgcolor="background.paper"
            >
              <b>{selectedStep.etapa_evento == CLIENTE_NOTIFICADO && !selectedStep.lista_destinatarios ? "O cliente não foi notificado por não ter email cadastrado no Siebel." : "Não existem informações adicionais para esse evento."}</b>
            </Box>
          </>
        )}
      </div>
    </Card>
  </Container>
);

export default EventStepCommentSection;
